export const confidenceColorClasses = {
  high: "bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400",
  medium:
    "bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400",
  low: "bg-rose-100 dark:bg-rose-900/50 text-rose-700 dark:text-rose-400",
} as const;

export const badgeBase = "px-2 py-0.5 text-[10px] font-semibold rounded-full";
